module.exports = __webpack_public_path__ + "img/taxi-drive-animation.c82c8c4f.gif";